var React = require('react');

function PlusSign (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#231f20;stroke-miterlimit:10;}")),React.createElement("line",{"className":"cls-1","x1":"9.86","x2":"9.86","y2":"19.71","key":1}),React.createElement("line",{"className":"cls-1","x1":"19.71","y1":"9.86","y2":"9.86","key":2})]);
}

PlusSign.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 19.71 19.71"};

module.exports = PlusSign;

PlusSign.default = PlusSign;
